import { render } from "./component-type.vue?vue&type=template&id=6d19eb32"
import script from "./component-type.vue?vue&type=script&setup=true&lang=js"
export * from "./component-type.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-type.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d19eb32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d19eb32', __exports__)) {
    api.reload('6d19eb32', __exports__)
  }
  
  module.hot.accept("./component-type.vue?vue&type=template&id=6d19eb32", () => {
    api.rerender('6d19eb32', render)
  })

}


export default __exports__